import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class FaqV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return  <section className="faq-two">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="faq-two__content">
                <div className="block-title-two text-left">
                  <p>why choose us</p>
                  <h3>Join Us &amp; Get Our <br /> Professional Service</h3>
                </div>{/* /.block-title-two */}
                <ul className="list-unstyled video-one__list">
                  <li>
                    <i className="far fa-check" />
                    Fast, guided automation for support, sales & engagement
                  </li>
                  <li>
                    <i className="far fa-check" />
                    Seamless integration with websites and social platforms
                  </li>
                  <li>
                    <i className="far fa-check" />
                    AI-driven conversations for higher conversions
                  </li>
                  <li>
                    <i className="far fa-check" />
                    Complete dashboard to manage leads and insights
                  </li>
                  <li>
                    <i className="far fa-check" />
                    24/7 availability without hiring additional staff
                  </li>
                  <li>
                    <i className="far fa-check" />
                    Custom scalable solutions for any business size
                  </li>
                </ul>
                <a href="/about" className="thm-btn faq-two__btn">Read More <i className="fa fa-angle-double-right" /></a>{/* /.thm-btn faq-two__btn */}
              </div>{/* /.faq-two__content */}
            </div>{/* /.col-lg-6 */}
            <div className="col-lg-6 d-flex justify-content-center">
              <div className="faq-two__image">
                <img src={publicUrl+"assets/images/resources/service-about.jpg"} alt={ imagealt } />
              </div>{/* /.faq-two__image */}
            </div>{/* /.col-lg-6 */}
          </div>{/* /.row */}
        </div>{/* /.container */}
      </section>

        }
}

export default FaqV2